module.exports = __webpack_public_path__ + "img/step1.4bd3ee70.png";